import { useCreateDocumentTypeMutation, useDocumentTypeQuery } from '../../generated/graphql';

import { Card } from 'react-bootstrap';
import { Formik } from 'formik';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { SubmitButton } from '../../components/Form/SubmitButton';
import { TextInput } from '../../components/Form';
import routes from '../../routes/routes';
import { useQuery } from '../../hooks';
import { useTranslation } from 'react-i18next';

type CreateDocumentTypeScreenProps = RouteComponentProps;

interface MyFormValues {
    name: string;
    commentForModerator: string;
    comment: string;
    additionalFields: string;
}

export const CreateDocumentTypeScreen: React.FC<CreateDocumentTypeScreenProps> = ({ history }) => {
    const query = useQuery();

    const isCategoryRaw = query.get('isCategory') || false;
    const parentId = query.get('parentId') || 0;
    const [t] = useTranslation();

    const { data, refetch } = useDocumentTypeQuery({
        variables: { id: +parentId },
    });

    const isDocument = isCategoryRaw === 'false' || !isCategoryRaw;
    const isCategory = !isDocument;

    const [createDocumentType] = useCreateDocumentTypeMutation();

    const valuesNames = data?.documentType.path.reduce((prevValue: string[], currentValue) => {
        if (!currentValue.valuesNames?.length) return prevValue;
        return [...prevValue, ...currentValue.valuesNames];
    }, []);

    const initialValues: MyFormValues = {
        name: '',
        comment: '',
        additionalFields: '',
        commentForModerator: '',
    };

    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={async ({ name, comment, commentForModerator, additionalFields, ...rest }, actions) => {
                    const values: any = {};
                    valuesNames?.forEach((element) => {
                        // @ts-ignore
                        values[element] = rest?.[element] || 0;
                    });

                    await createDocumentType({
                        variables: {
                            input: {
                                name,
                                parentId: +parentId,
                                isCategory: !!isCategory,
                                comment,
                                commentForModerator,
                                additionalFields,
                                values: JSON.stringify(values),
                            },
                        },
                    });
                    refetch();
                    history.push({ pathname: `${routes.documentType}/${parentId}` });
                }}
            >
                <div>
                    <Card.Title>
                        {isCategory
                            ? t('admin.pages.create_document_type.create_category')
                            : t('admin.pages.create_document_type.create_document')}
                    </Card.Title>
                    <TextInput
                        name="name"
                        label={t('admin.pages.create_document_type.name_input')}
                        placeholder={t('admin.pages.create_document_type.name_input_placeholder')}
                    />
                    <TextInput
                        name="category2"
                        label={t('admin.pages.create_document_type.parent_category')}
                        value={data?.documentType.path.map((e) => e.name).join(' -> ')}
                        disabled={true}
                    />
                    {isDocument && (
                        <div>
                            <TextInput
                                name="comment"
                                label={t('admin.pages.create_document_type.comment_input')}
                                placeholder={t('admin.pages.create_document_type.comment_input_placeholder')}
                            />
                            <TextInput
                                name="commentForModerator"
                                label={t('admin.pages.create_document_type.comment_for_moderator_input')}
                                placeholder={t(
                                    'admin.pages.create_document_type.comment_for_moderator_input_placeholder',
                                )}
                            />

                            {['points']?.map((item) => (
                                <TextInput name={item} label={'Кількість балів'} key={item} />
                            ))}
                            <div style={{ marginTop: 10 }} />
                        </div>
                    )}

                    <SubmitButton>{t('admin.pages.create_document_type.submit_button')}</SubmitButton>
                </div>
            </Formik>
        </div>
    );
};
